import {ok} from 'framework';
import type {Result} from 'framework';
import type {KeyValueStoragePort} from '@/shared/application/ports/key-value-storage.port';
import type {OnboardingStatus} from '../../domain/onboarding-status.value-object';
import type {OnboardingStatusRepository} from '../../application/ports/onboarding-status.repository';

export const ONBOARDING_COMPLETED_STORAGE_KEY = 'onboarding:completed:v1';

const COMPLETED_VALUE = '1';

/**
 * Stores the onboarding-completion flag in a {@link KeyValueStoragePort}.
 * Storage failures fall back to "not complete" so the UI can re-show the
 * onboarding step instead of leaving the user stuck.
 */
export class KeyValueOnboardingStatusRepository implements OnboardingStatusRepository {
  constructor(private readonly storage: KeyValueStoragePort) {}

  async getStatus(): Promise<Result<OnboardingStatus>> {
    const result = await this.storage.get(ONBOARDING_COMPLETED_STORAGE_KEY);

    if (!result.ok) {
      return ok('not_complete');
    }

    return ok(result.data === COMPLETED_VALUE ? 'complete' : 'not_complete');
  }

  markComplete(): Promise<Result<void>> {
    return this.storage.set(ONBOARDING_COMPLETED_STORAGE_KEY, COMPLETED_VALUE);
  }
}
